import { forwardRef } from "react";
import PropTypes from "prop-types";

const InputText = forwardRef(
  ({ label, placeholder, error, name, details, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {(label || details) && (
          <div className="flex justify-between items-center">
            {label && (
              <label
                htmlFor={name}
                className="text-base md:text-sm font-medium"
              >
                {label}
              </label>
            )}
            {details && <span className="text-xs md:text-xs">{details}</span>}
          </div>
        )}

        <input
          id={name}
          name={name}
          ref={ref}
          placeholder={placeholder}
          {...props}
          className={`w-full text-base md:text-sm px-4 py-1.5 input-base transition focus:outline-none border rounded-md ${
            error
              ? "border-red-500! focus:ring-red-500 focus:border-red-500"
              : "card-base-border focus:ring-blue-500 focus:border-blue-500"
          }`}
        />

        {error && <p className="text-xs text-red-500! mt-1">{error}</p>}
      </div>
    );
  }
);

InputText.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  details: PropTypes.string,
};

InputText.displayName = "InputText";

export default InputText;
